export enum LiveUpdateServiceType {
  // Azure PubSub is enabled - Ably is disabled
  AZURE_PUBSUB = 'true',
  // Azure PubSub is enabled - Ably is enabled
  SHADOW = 'shadow',
  // Azure PubSub is disabled - Ably is enabled
  ABLY = 'false',
}

export interface LiveUpdateSettings {
  liveUpdateService: LiveUpdateServiceType;
}
